import { render, staticRenderFns } from "./bulletFrame.vue?vue&type=template&id=493c5cef&scoped=true"
import script from "./bulletFrame.vue?vue&type=script&lang=js"
export * from "./bulletFrame.vue?vue&type=script&lang=js"
import style0 from "./bulletFrame.vue?vue&type=style&index=0&id=493c5cef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c5cef",
  null
  
)

export default component.exports